import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface UserProfile {
  userId: number;
  name: string;
  surname: string;
  email: string;
  level: number;
  studio: {
    name: string;
  };
  dateCreated: string;
}

const queryOptions = {
  queryKey: ['profile'],
  queryFn: async () => {
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/profile`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      return data;
    } catch (error: any) {
      if ( error.response && error.response.status === 401 && error.response.data.error === "Invalid or missing API key"
      ) { 
        logout()
      } 
      throw error;
    } 
  },
} as any;

export const useProfile = () => {
  return useQuery<UserProfile, Error>(queryOptions);
};
